<template>
	<div class="keyword-view" v-outside="closeBox">
		<ul class="keyword-view__lists" v-if="lists.length > 0">
			<li v-for="(data,index) in lists" @click.stop="handleClick(data)" :key="index">
				<el-popover placement="right" trigger="hover" width="300">
					<text-message :content="data.content" v-if="data.type == 'text'"></text-message>
					<image-message :src="data.attachment.fileurl" v-if="data.type == 'image'"></image-message>
					<file-message :file="data.attachment" v-if="data.type == 'file'"></file-message>
					<video-message :src="data.attachment.url" v-if="data.type == 'video'"></video-message>
					<card-message :data="data"  v-if="data.type == 'news'" keys="other"></card-message>
					<link-message :data="data" v-if="data.type == 'link'"></link-message>
					<mini-program-message :data="data.miniProgram" v-if="data.type == 'miniprogrampage'" :isShowMoney="true"></mini-program-message>
					<span slot="reference" class="desc-box">
						<i class="iconfont" :class="setIcon(data)"></i>
						<span class="title">{{ data.name }}</span>
					</span>
				</el-popover>
			</li>
			<li>
				<el-button class="more-btn" type="text" :loading="loading" @click="toMore" :disabled="isDisabled">
						{{ loading ? '加载中' : isDisabled ? '没有更多数据咯' : '更多'}}
				</el-button>
			</li>
		</ul>
		<el-empty description="暂无数据" v-else class="keyword-view__lists"></el-empty>
		<div class="keyword-view__types">
			<el-radio-group v-model="type" size="mini" @change="onChange">
			  <el-radio-button label="">全部</el-radio-button>
			  <el-radio-button label="text">文本</el-radio-button>
			  <el-radio-button label="image">图片</el-radio-button>
			  <el-radio-button label="file">文件</el-radio-button>
			  <el-radio-button label="news">图文</el-radio-button>
			  <!-- <el-radio-button label="link">链接</el-radio-button> -->
			  <el-radio-button label="miniprogrampage">小程序卡片</el-radio-button>
			</el-radio-group>
		</div>
		<span class="el-icon-circle-close" @click="closeBox"></span>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { isCanSend } from '@/utils/imService';
	
	export default {
		computed:{
			...mapState({
				brandId: state => state.user.brandId,
				index_infos: state => state.imChatService.index_infos
			})
		},
		model: {
			prop: 'show',
			event: 'close',
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			keyword:{
				default:''
			}
		},
		watch: {
			keyword(data) {
				this.listQuery.pageNum = 1
				this.lists = []
				this.initData(data)
			},
		},
		data(){
			return {
				listQuery:{
					pageNum:1,
					pageSize:10
				},
				lists:[],
				isDisabled:false,
				loading:false,
				type:'',
			}
		},
		
		methods:{
			closeBox() {
				this.$emit('close', false)
			},
			handleClick(data) {
				if(!isCanSend(this.index_infos.channel,data.type)) return this.$message.error('抱歉，该渠道禁止发送此类型消息');
				this.$emit('confirm',data)
			},
			onChange(){
				this.listQuery.pageNum = 1;
				this.lists = [];
				this.initData(this.keyword);
			},
			initData(val){
				if(!this.show) return;
				this.loading = true
				let texts = [];
				texts.push(val || '')
				let params = {
					"enabledKey": false,
					"texts":texts,
					 "type":this.type
				}
				this.$api.searchImServiceSpeech(`/ocs-kdb/tips/${this.brandId}/search?page=${this.listQuery.pageNum}&size=${this.listQuery.pageSize}`,
				params).then(res => {
					this.loading = false
					if(res.errcode != 0) return;
						this.isDisabled = res.pages <= this.listQuery.pageNum;
						if(this.lists.length > 0) { 
							this.lists = this.lists.concat(res.list);
							return;
						}
						this.lists = res.list
					
				})
			},
			toMore(){
				this.listQuery.pageNum++
				this.initData(this.keyword)
			},
			setIcon(data) {
				let icon = "";
				switch(data.type){
					case 'text':
						icon = 'major-text'
						break;
					case 'image':
						icon = 'major-tianchongxing-'
						break;
					case 'file':
						icon = 'major-files'
						break;
					case 'miniprogrampage':
						icon = 'major-xiaochengxu'
						break;
					case 'video':
						icon = 'major-lianxi2hebing_shipin'
						break;
					case 'voice':
						icon = 'major-Voice2'
						break;
					case 'news':
						icon = 'major-news'
						break;
					case 'link':
						icon = 'major-weixinxiaochengxu'
						break;
					default:
						icon = "major-ziyuan";
					
				}
				return icon;
			},
		},
		mounted() {
			 this.initData()
		}
	}
</script>

<style lang="scss" scoped>
	.keyword-view {
		width: 100%;
		height:340px;
		background-color: #fff;
		position: absolute;
		bottom: 270px;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		padding: 0;
		overflow: hidden;
		box-sizing: border-box;
		cursor: pointer;
		font-size: 14px;
		color: #838A9D;
		&__lists {
			height: 90%;
			padding: 10px 0;
			box-sizing: border-box;
			overflow-y: scroll;
			li {
				 list-style: none;
				 padding: 6px 20px;
				 width: 100%;
				 > span {
					 max-width: 100%;
				 }
				 &:hover {
					 background-color: #EDF5FF;
					 color: #3C4353;
				 }
				 .iconfont {
					 font-size: 20px;
					 margin-right: 5px;
				 }
				 .desc-box {
					vertical-align:middle;
				 }
				 .title {
					 display: inline-block;
					 max-width: calc(100% - 30px);
					 overflow: hidden;
					 text-overflow: ellipsis;
					 white-space: nowrap;
				 }
			}
			.more-btn {
				 text-align: center;
				 display: block;
				 margin: auto;
			}
		}
		.el-icon-circle-close {
			 position: absolute;
			 right: 10px;
			 top: 8px;
			 font-size: 16px;
			 color: #FF504D;
			
		 }
		 &__types {
			 width: 100%;
			 height: 10%;
			 display: flex;
			 align-items: center;
			 justify-content: center;
		 }
	}
</style>
